/**
 * Translates role values from English to Polish
 * @param role - Role value in English (e.g., "TECHNICIAN", "ADMIN")
 * @returns Translated role in Polish
 */
export const translateRole = (role: string): string => {
  const roleTranslations: Record<string, string> = {
    TECHNICIAN: 'Technik',
    SUPER_ADMIN: 'Super Administrator',
    ADMIN: 'Administrator',
    CLIENT: 'Klient',
  };

  return roleTranslations[role.toUpperCase()] || role;
};
